export default "__VITE_ASSET__BzY8dMgA__"